import axios from "axios";
import router from "../router";
//单独引入message提示组件
import { Message } from 'element-ui';
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  // console.log('---进入tip提示---')
  Message({
    showClose: true,
    message: msg,
    type: 'error',
    duration:2000
  });
}
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
}
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // console.log("----进入-errorHandle-----::"+status)
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 402:
      tip('登录过期');
      window.sessionStorage.clear();
      window.localStorage.clear();
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    case 403:
      tip('登录过期，请重新登录');
      window.sessionStorage.clear();
      window.localStorage.clear();
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      tip('请求的资源不存在');
      break;
    case 400:
      tip('400错误');
      break;
    default:
      // console.log(other);
      tip('资源请求错误');
      break;

  }
}
// 创建axios实例
const instance = axios.create({    timeout: 1000 * 12});
//每次请求带上cooki,防止每次请求sessionid不同
instance.defaults.withCredentials=true;
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//请求拦截器
instance.interceptors.request.use(config=>{
  config.headers.Authorization=window.sessionStorage.getItem("token");
  return config;
})
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res)
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      // store.commit('changeNetwork', false);
      window.sessionStorage.setItem("changeNetwork","0");
    }
  });

export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js